import React from 'react';
import { Helmet } from 'react-helmet-async';

const SITE = 'https://americaninstituteofanalytics.com';
const DEFAULT_OG = `${SITE}/og-share-card.png`;

/**
 * Per-page SEO component. Pass at least `title` and `description`.
 * Optional: `path` (canonical), `image` (override OG card), `type` (article|website).
 *
 * Usage:
 *   <SEO title="Tutorials" description="Hands-on AI/ML tutorials" path="/tutorials" />
 */
export default function SEO({
  title,
  description,
  path = '',
  image,
  type = 'website',
  noindex = false,
  jsonLd = null,
}) {
  const fullTitle = title
    ? `${title} | Institute of Analytics USA`
    : 'Institute of Analytics USA | Learn AI, ML, DS - Get Hired';
  const desc = description ||
    'Institute of Analytics USA - PG Diploma in AI, ML & Data Science Engineering. 6 courses, 120 hours. 200+ graduates, 100% employed, $80K+ starting salary.';
  const canonical = `${SITE}${path || ''}`;
  const ogImage = image || DEFAULT_OG;

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={canonical} />
      {noindex && <meta name="robots" content="noindex, nofollow" />}

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={canonical} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImage} />

      {/* Per-page JSON-LD if provided */}
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
}
